module.exports = __webpack_public_path__ + "img/index_pic9.b61aabfd.png";